// eslint-disable-next-line
export const en = {
	"404": "404",
};